import { ConditionValue } from '@makyoapp/makyo-common'

import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { ConditionRepeaterV2 } from '@/components/BehaviourV2/ConditionRepeaterV2'

interface VisibilityFieldSettingProps {
  id: string
  value: any
}

export default function VisibilityFieldSetting({ id, value }: VisibilityFieldSettingProps) {
  const updateValue = useUpdateCompSettingValue(id)
  return <ConditionRepeaterV2 value={value as ConditionValue} onChange={updateValue} />
}
